import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const [index, setIndex] = useState<number>(0);
  const [direction, setDirection] = useState<number>(1);
  const total = pageSamples.length;
  const current = pageSamples[index];
  const go = (next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + total) % total);
  };
  return <section id="inside-pages" className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-118" data-mp="31xnaxe76rbgu">
      <div className="mx-auto max-w-5xl" data-id="element-119" data-mp="2x52gqbkdawcs">
        <div className="mx-auto max-w-2xl text-center" data-id="element-120" data-mp="2x416g9b6edw4">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-121" data-mp="2s7kibf3z7zj1">
            Feuilletez le matériel
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-122" data-mp="3pnhlfp418nxx">
            Découvrez les pages{' '}
            <span className="italic text-brand" data-id="element-123" data-mp="1mm2w40vqn7ge">de l&apos;intérieur.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-124" data-mp="1rlz0w2c9f2x0">
            Des pages réelles du pack, des premiers mots en A1 aux grilles
            d&apos;évaluation C2.
          </p>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-[minmax(0,1fr)_18rem] md:items-center" role="group" aria-roledescription="carrousel" aria-label="Pages d'exemple du matériel" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        }
      }} data-id="element-125" data-mp="1huktz9hzb0tu">
          <div className="relative flex h-[26rem] items-center justify-center overflow-hidden rounded-3xl bg-white p-4 shadow-soft sm:h-[34rem] sm:p-6" data-id="element-126" data-mp="2p7d0ogt60ftv">
            <AnimatePresence initial={false} mode="wait" custom={direction} data-id="element-127" data-mp="6350oe38johx">
              <motion.img key={current.src} src={current.src} alt={`${current.title} — page d'exemple, niveau ${current.level}`} custom={direction} initial={{
              opacity: 0,
              x: direction * 32
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction * -32
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="h-full w-full object-contain" data-id="element-128" data-mp="12zevejncw7r" />
            </AnimatePresence>

            <button type="button" onClick={() => go(index - 1)} aria-label="Page précédente" className="absolute left-3 top-1/2 inline-flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-ink/85 text-white transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-129" data-mp="fyf0qwa2plt2">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-130" data-mp="1g14qa8n6a0li" />
            </button>
            <button type="button" onClick={() => go(index + 1)} aria-label="Page suivante" className="absolute right-3 top-1/2 inline-flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-ink/85 text-white transition-[transform,background-color] duration-150 ease-out hover:scale-105 hover:bg-brand focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30" data-id="element-131" data-mp="1kyda0dnyycov">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-132" data-mp="28p0urzizgwsu" />
            </button>
          </div>

          <div className="flex flex-col" data-id="element-133" data-mp="2cqvxn8gkbi8q">
            <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-134" data-mp="2crxb1jl1wgtm">
              {current.level}
            </p>
            <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink" data-id="element-135" data-mp="2hncintsgtghl">
              {current.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-136" data-mp="2026dkm3fjopz">
              {current.caption}
            </p>
            <p className="mt-5 text-xs font-bold tabular-nums text-ink/40" data-id="element-137" data-mp="2drqdlk5mm7vl">
              {index + 1} / {total}
            </p>

            <ul className="mt-6 flex gap-3 overflow-x-auto pb-2 md:flex-wrap md:overflow-visible" data-id="element-138" data-mp="28ugltxurlk4l">
              {pageSamples.map((page, pageIndex) => <li key={page.src} data-id="element-139" data-mp="1h3albgb4tkes" data-mpi={pageIndex}>
                  <button type="button" onClick={() => go(pageIndex)} aria-label={`Aller à ${page.title}`} aria-current={pageIndex === index} className={`h-16 w-12 shrink-0 overflow-hidden rounded-lg border-2 bg-white transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 ${pageIndex === index ? 'border-brand' : 'border-ink/10 hover:border-ink/30'}`} data-id="element-140" data-mp="1h4bwdks5e6wi">
                    <img src={page.src} alt="" className="h-full w-full object-cover object-top" data-id="element-141" data-mp="s7bi242gr6hl" />
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}